import React, { FC, useEffect, useState } from "react";
import { NavLink } from "react-router";

import { Box, Button, Divider } from "../ui";
import { Package } from "../../models/package.type";
import { Attraction } from "../../models/attraction.type";
import useHumanTimeLocale from "../../hooks/use-human-time-locale";
import { pages } from "../../utils/routrer-utils";

import MediaFile, { FileItem } from "./media-file";
import styles from "./index.module.css";

type FileListProps = {
  pack: Package;
  attraction: Attraction;
};

const FileList: FC<FileListProps> = (props) => {
  const { pack, attraction } = props;
  const [checkedList, setCheckedList] = useState<Array<FileItem>>([]);
  const humanTime = useHumanTimeLocale();

  useEffect(() => {
    if (pack.package_items) {
      const newItems: Array<FileItem> = pack.package_items.map((item) => ({
        ...item,
        check: false,
      }));
      setCheckedList(newItems);
    }
  }, [pack.package_items]);

  const renderFiles = checkedList.map((item, index) => (
    <MediaFile key={index} item={item} />
  ));

  return (
    <Box className={styles.container}>
      <div className={styles.header}>
        <div className={styles.infoContainer}>
          <h2 className={styles.title}>{attraction.name}</h2>
          <div className={styles.date}>
            {humanTime.dateMDY(pack.date_time_creation)}
          </div>
        </div>
        <div>
          <NavLink to={pages.HELP}>
            <Button
              variant="outlined"
              padding={22}
              size="large"
              label="Вопросы по видео?"
            />
          </NavLink>
        </div>
      </div>
      <Divider />
      <div className={styles.filesContainer}>{renderFiles}</div>
      <Divider />
    </Box>
  );
};

export default FileList;
